import { Component, OnInit, Input } from '@angular/core';
import { clone } from 'lodash';

@Component({
  selector: 'app-expandable-list',
  templateUrl: './expandable-list.component.html',
  styleUrls: ['./expandable-list.component.sass']
})
export class ExpandableListComponent implements OnInit {
  @Input() list: any = [];
  @Input() limit = 3;
  @Input() separator = ', ';
  @Input() placeholder = null;
  @Input() key = null;

  expanded = false;

  constructor() { }

  ngOnInit() {
  }

  getCompleteList() {
    const list = this.normalizeList();
    return list.join(this.separator);
  }

  getTruncatedList() {
    const list = this.normalizeList();
    return list.slice(0, this.limit).join(this.separator);
  }

  getRemaining() {
    const list = this.normalizeList();
    const remaining = list.length - this.limit;

    if (remaining > 0) {
      return remaining;
    }
  }

  private normalizeList() {
    let list = clone(this.list || []);

    if (this.key) {
      list = list.map((item) => item[this.key]);
    }

    return list;
  }
}
